<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW') && shipInstallations.length > 0">
  <div class="card-heading">
    <span class="cardHeaderHeading"> Tablet Connection Status </span>
  </div>
  <div class="card-body" *ngIf="shipInstallations">
    <table class="table table-striped table-bordered">
      <thead class="tableheading">
      <tr>
        <th class="text-center transactionHistHeader" style="width: 50%">Host Name</th>
        <th class="text-center transactionHistHeader" style="width: 50%">Last Seen Date Time</th>
      </tr>
      </thead>
      <tbody style="background-color: #ffffff;">
      <tr
        *ngFor="
            let lastSeenDetail of shipInstallations
          "
      >
        <td class="text-center transactionHistText">
          {{ lastSeenDetail.hostName }}
        </td>
        <td class="text-center transactionHistText">
          {{ lastSeenDetail.lastSeen }}
        </td>
      </tr>
      </tbody>
    </table>
    <table class="table table-striped table-bordered" *ngIf="lastEOMDetails">
      <thead class="tableheading">
      <tr>
        <th class="text-center transactionHistHeader" style="width: 5%">EOM</th>
        <th class="text-center transactionHistHeader" style="width: 30%">Last Run Time</th>
        <th class="text-center transactionHistHeader" style="width: 5%">Reports</th>
      </tr>
      </thead>
      <tbody style="background-color: #ffffff;">
      <ng-container
        *ngIf="
              lastEOMDetails[0].hasEOM === 'Yes'
            ">
        <tr
          *ngFor="
            let lastEOMDetail of lastEOMDetails
          ">
          <td class="text-center transactionHistText">
            {{ lastEOMDetail.hasEOM }}
          </td>
          <td class="text-center transactionHistText">
            {{ lastEOMDetail.lastRunTime }}
          </td>
          <td
            class="text-center"
            *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_REPORTS_LINK')"
          >
            <div>
              <a (click)="gotoShipReports(lastEOMDetail.batchId)">
                <i class="fa fa-file-text-o" style="color: grey"></i>
              </a>
            </div>
          </td>
        </tr>
      </ng-container>
      <tr
        *ngIf="
            lastEOMDetails[0].hasEOM === 'No'
          ">
        <td class="text-center transactionHistText">
          {{ lastEOMDetails[0].hasEOM }}
        </td>
        <td class="text-center transactionHistText">
          N/A
        </td>
        <td class="text-center transactionHistText">
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW') && shipInstallations.length == 0">
  <div class="card-heading">
    <i class="fa fa-retweet"></i>
    <span class="cardHeaderHeading"> Roundtrip Overview </span>
  </div>
  <div class="card-body card-pad-15" *ngIf="shipRoundTripHistory">
    <div class="row">
      <div class="columnBorder col-md-4">
        <div class="row col-centered">
          <span class="labelCommon">Current Roundtrip Status</span><br />
          <span class="staticText1"
            >{{
              shipRoundTripHistory.currentRoundTripStatus
            }}&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <i
            [ngClass]="
              shipRoundTripHistory.currentRoundTripStatus | processingStatusPipe
            "
          ></i>
        </div>
      </div>
      <div class="columnBorder col-md-4">
        <div class="row col-centered">
          <span class="labelCommon">Hours Since Last RoundTrip</span><br />
          <span class="staticText1"
            >{{
              shipRoundTripHistory.roundtripGapHours
            }}&nbsp;&nbsp;&nbsp;</span
          >
          <i
            [ngClass]="
              shipRoundTripHistory.roundtripGapHours
                | hoursSinceLastRoundtripPipe
            "
          ></i>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row col-centered">
          <span class="labelCommon"> Round Trip Interval(minutes) </span><br />
          <span class="staticText1">{{ ship.autoRoundTripInterval }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
